import React, { useContext } from 'react';
import MessengerFillIcon from 'components/lib/icons/messenger_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function MessengerRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.fbMessage;
  const messengerSla = sla.fbMessage;
  return (
    <FloorboardRow
      newItems={stats.currentNewMessages}
      activeItems={stats.currentOpenMessages}
      currentWait={stats.currentWait}
      sla={messengerSla}
      activeLabel="Active Messages"
      newLabel="New Messages"
      waitLabel="Oldest Unanswered Message"
      icon={<MessengerFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/messenger_row.jsx